<template>
  <div class="main-wrapper">
    <layout-header/>
    <layout-sidebar/>
    <div class="page-wrapper">
      <div class="content container-fluid">
        <div class="contact-details-skeleton">
          <!-- Profile header skeleton -->
          <div class="skeleton-profile-header">
            <div class="skeleton-avatar"></div>
            <div class="skeleton-profile-info">
              <div class="skeleton-name"></div>
              <div class="skeleton-number"></div>
              <div class="skeleton-address"></div>
            </div>
          </div>

          <!-- Tabs skeleton -->
          <div class="skeleton-tabs">
            <div class="skeleton-tab"></div>
            <div class="skeleton-tab"></div>
            <div class="skeleton-tab"></div>
          </div>

          <!-- Content skeleton -->
          <div class="skeleton-content">
            <div class="skeleton-card">
              <div class="skeleton-card-header"></div>
              <div class="skeleton-card-body">
                <div class="skeleton-field"></div>
                <div class="skeleton-field"></div>
                <div class="skeleton-field"></div>
                <div class="skeleton-field"></div>
                <div class="skeleton-field"></div>
                <div class="skeleton-field"></div>
                <div class="skeleton-field"></div>
                <div class="skeleton-field"></div>
                <div class="skeleton-field"></div>
                <div class="skeleton-field"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContactDetailsSkeleton'
};
</script>

<style scoped>
.contact-details-skeleton {
  width: 100%;
  padding: 20px;
  background-color: #fff;
}

.skeleton-profile-header {
  display: flex;
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 8px;
  margin-bottom: 20px;
}

.skeleton-avatar {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  margin-right: 20px;
}

.skeleton-profile-info {
  flex: 1;
}

.skeleton-name {
  width: 200px;
  height: 24px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 4px;
  margin-bottom: 10px;
}

.skeleton-number, .skeleton-address {
  width: 150px;
  height: 16px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 4px;
  margin-bottom: 8px;
}

.skeleton-tabs {
  display: flex;
  margin-bottom: 20px;
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 10px;
}

.skeleton-tab {
  width: 100px;
  height: 32px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 4px;
  margin-right: 10px;
}

.skeleton-content {
  padding: 10px;
}

.skeleton-card {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
}

.skeleton-card-header {
  height: 50px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

.skeleton-card-body {
  padding: 20px;
}

.skeleton-field {
  height: 40px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 4px;
  margin-bottom: 15px;
}

@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ContactDetails/ContactDetailsSkeleton.vue